import React, { Component } from 'react';
import { Link, withRouter } from 'react-router-dom';
import { getEmbedInfo } from '../store/actions';
import { connect } from 'react-redux';
import Loader, { Loader2 } from '../Components/Loader';
import ReactApexChart from 'react-apexcharts';
import { Checkbox, Radio, List, Progress, Select } from 'antd';
import { Table, Typography } from 'antd';
import {
  ReduxSelect,
  ReduxInput,
  ReduxDateInput,
} from '../component/custom-redux-components/index.js';

import {
  Pie,
  // Bar,
  // HorizontalBar,
  // Line,
  // Doughnut,
} from 'react-chartjs-2';
import 'chartjs-plugin-datalabels';
import PageTitle from '../Components/PageTitle';
import { PowerBIEmbed } from 'powerbi-client-react';
import { models } from 'powerbi-client';

const { Option } = Select;
const triggerColumns = [
  {
    title: 'Category',
    dataIndex: 'Triggerheader',
    key: 'Triggerheader',
    render: (text, record) => {
      return (
        <div className="">
          <span className={record.IsBold ? 'font-weight-bold' : ''}>{text}</span>
        </div>
      );
    },
  },
  {
    title: 'Count',
    dataIndex: 'TriggerValue',
    key: 'TriggerValue',
    align: 'right',
    render: (text, record) => {
      return (
        <div className="">
          <span className={record.IsBold ? 'font-weight-bold' : ''}>{text}</span>
        </div>
      );
    },
  },
];

const ProviderColumns = [
  {
    title: 'Provider Name',
    dataIndex: 'ProviderName',
    key: 'ProviderName',
    width: 150,
    fixed: 'left',
    render: (text, record) => {
      return (
        <div className="">
          <span className={record.IsBold ? 'font-weight-bold' : ''}>{text}</span>
        </div>
      );
    },
  },
  {
    title: 'Clients Served',
    dataIndex: 'ClientCount',
    key: 'ClientCount',
    width: 80,
    // children: [
    //   {
    //     title: '',
    //     dataIndex: 'ClientCount',
    //     key: 'ClientCount',
    //     align: 'right',
    //     width: 80,
    //     render: (text, record) => {
    //       return (
    //         <div className="">
    //           <span className={record.IsBold ? 'font-weight-bold' : ''}>{text}</span>
    //         </div>
    //       );
    //     },
    //   },
    // ],
  },
  {
    title: 'Score increase in SP Behavioral Rating Over Time(Days)',
    children: [
      {
        title: '30',
        dataIndex: 'Day30',
        key: 'Day30',
        width: 70,
        align: 'right',
        render: (text, record) => {
          return (
            <div className="">
              <span className={record.IsBold ? 'font-weight-bold' : ''}>{text}</span>
            </div>
          );
        },
      },
      {
        title: '60',
        dataIndex: 'Day60',
        key: 'Day60',
        width: 70,
        align: 'right',
        render: (text, record) => {
          return (
            <div className="">
              <span className={record.IsBold ? 'font-weight-bold' : ''}>{text}</span>
            </div>
          );
        },
      },
      {
        title: '90',
        dataIndex: 'Day90',
        key: 'Day90',
        width: 70,
        align: 'right',
        render: (text, record) => {
          return (
            <div className="">
              <span className={record.IsBold ? 'font-weight-bold' : ''}>{text}</span>
            </div>
          );
        },
      },
      {
        title: '120',
        dataIndex: 'Day120',
        key: 'Day120',
        width: 70,
        align: 'right',
        render: (text, record) => {
          return (
            <div className="">
              <span className={record.IsBold ? 'font-weight-bold' : ''}>{text}</span>
            </div>
          );
        },
      },
      {
        title: '150+',
        dataIndex: 'Day150',
        key: 'Day150',
        width: 70,
        align: 'right',
        render: (text, record) => {
          return (
            <div className="">
              <span className={record.IsBold ? 'font-weight-bold' : ''}>{text}</span>
            </div>
          );
        },
      },
    ],
  },
];

const { Text } = Typography;
// const barSeries = [{
//   name: 'Website Blog',
//   type: 'column',
//   data: [8489, 9322, 10631, 11219, 12564, 13224]
// }, {
//   name: 'Social Media',
//   type: 'line',
//   data: [435, 833, 1309, 588, 1345, 660],
//   // data: [1000, 3000, 6000, 9000, 12000, 15000]
// }];
// const barOptions = {

//   plotOptions: {
//     bar: {
//       horizontal: false,
//       dataLabels: {
//         position: 'top'
//       },
//       columnWidth: '50%',
//       // distributed: true
//     }
//   },
//   chart: {
//     height: 350,
//     type: 'line',
//     zoom: {
//       enabled: false
//     },
//     toolbar: {
//       show: false
//     }
//   },
//   stroke: {
//     width: [0, 4]
//   },
//   title: {
//     text: 'Legacy New'
//   },
//   dataLabels: {
//     enabled: true,
//     // enabledOnSeries: [1]
//   },
//   labels: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun'],
//   xaxis: {
//     type: 'category',

//   },
//   yaxis: [{
//     title: {
//       text: 'Total',
//     },

//   }, {
//     opposite: true,
//     title: {
//       text: 'New Added'
//     }
//   }]
// };

const treatmentSeries = [44, 16, 12, 12, 16];
const treatmentOptions = {
  chart: {
    width: 380,
    type: 'pie',
  },
  stroke: {
    width: 0,
  },
  legend: {
    show: false,
  },
  tooltip: {
    enabled: false,
  },
  colors: ['#4F99D2', '#2FBB7D', '#D85C5C', '#FFA800', '#1A45DF'],
  responsive: [
    {
      breakpoint: 480,
      options: {
        chart: {
          width: 200,
        },
        legend: {
          position: 'bottom',
        },
      },
    },
  ],
};

const referralSeries = [28, 26, 39, 7];
const referralOptions = {
  chart: {
    width: 380,
    type: 'pie',
  },
  stroke: {
    width: 0,
  },
  legend: {
    show: true,
    // position: 'bottom',
    // horizontalAlign: 'center',
  },
  tooltip: {
    enabled: true,
  },
  labels: ['Team A', 'Team B', 'Team C', 'Team D'], //mouse over text
  colors: ['#2FBB7D', '#D85C5C', '#FFA800', '#4F99D2'],
  responsive: [
    {
      breakpoint: 480,
      options: {
        chart: {
          width: 200,
        },
        legend: {
          position: 'bottom',
        },
      },
    },
  ],
};

// function generateData(baseval, count, yrange) {
//   debugger;
//   var i = 0;
//   var series = [];
//   while (i < count) {
//     var x = Math.floor(Math.random() * (750 - 1 + 1)) + 1;;
//     var y = Math.floor(Math.random() * (yrange.max - yrange.min + 1)) + yrange.min;
//     var z = Math.floor(Math.random() * (75 - 15 + 1)) + 15;

//     series.push([x, y, z]);
//     baseval += 86400000;
//     i++;
//   }
//   debugger;
//   return series;
// }

//Columns for Tables
const servicesDeliveredColumns = [
  {
    title: 'Types of Services',
    dataIndex: 'TypeOfService',
    key: 'TypeOfService',
  },
  {
    title: 'No. Of Events',
    dataIndex: 'EventCount',
    key: 'EventCount',
    align: 'right',
  },
  {
    title: 'Participants',
    dataIndex: 'Participants',
    key: 'Participants',
    align: 'right',
  },
];

const timeInTreatmentColumns = [
  {
    title: 'No. of Days',
    dataIndex: 'TimeInProgram',
    key: 'TimeInProgram',
  },
  {
    title: 'Clients',
    dataIndex: 'Total',
    key: 'Total',
    align: 'right',
    render: (text, record) => {
      return (
        <div className="">
          <span>
            {new Intl.NumberFormat('en-US', { maximumSignificantDigits: 7 }).format(text)}
          </span>
        </div>
      );
    },
  },
];

const referralSourceColumns = [
  {
    title: 'Source',
    dataIndex: 'Description',
    key: 'Description',
  },
  {
    title: 'Number',
    dataIndex: 'ReferralCount',
    key: 'ReferralCount',
    align: 'right',
    render: (text, record) => {
      return (
        <div className="">
          <span>
            {new Intl.NumberFormat('en-US', { maximumSignificantDigits: 7 }).format(text)}
          </span>
        </div>
      );
    },
  },
];

const standardCostOfCareColumns = [
  {
    title: 'Care Status',
    dataIndex: 'CareStatus',
    key: 'CareStatus',
    render: (text, record) => {
      return (
        <div className="">
          <span className={record.IsBold ? 'font-weight-bold' : ''}>{text}</span>
        </div>
      );
    },
  },
  {
    title: 'Client Count',
    dataIndex: 'ClientCount',
    key: 'ClientCount',
    render: (text, record) => {
      return (
        <div className="">
          <span className={record.IsBold ? 'font-weight-bold' : ''}>{text}</span>
        </div>
      );
    },
    align: 'right',
  },
  {
    title: 'Cost/Pop',
    dataIndex: 'TotalCost',
    key: 'TotalCost',
    render: (text, record) => {
      return (
        <div className="">
          <span className={record.IsBold ? 'font-weight-bold' : ''}>{text}</span>
        </div>
      );
    },
    align: 'right',
  },
  {
    title: 'Client Avg',
    dataIndex: 'ClientAvg',
    key: 'ClientAvg',
    render: (text, record) => {
      return (
        <div className="">
          <span className={record.IsBold ? 'font-weight-bold' : ''}>{text}</span>
        </div>
      );
    },
    align: 'right',
  },
];

//Data Source for Tables

const programColumns = [
  {
    title: 'Category',
    dataIndex: 'Category',
    key: 'Category',
    render: (text, record) => {
      return (
        <div className="">
          <span className={record.IsBold ? 'font-weight-bold' : ''}>{text}</span>
        </div>
      );
    },
  },
  {
    title: 'No. of Clients',
    dataIndex: 'NoOfClients',
    key: 'NoOfClients',
    render: (text, record) => {
      return (
        <div className="">
          <span className={record.IsBold ? 'font-weight-bold' : ''}>{text}</span>
        </div>
      );
    },
    align: 'right',
  },
  {
    title: 'Days in Program',
    dataIndex: 'LengthofStay',
    key: 'LengthofStay',
    render: (text, record) => {
      return (
        <div className="">
          <span className={record.IsBold ? 'font-weight-bold' : ''}>{text}</span>
        </div>
      );
    },
    align: 'right',
  },
];

const scoreColumns = [
  {
    title: 'Progress',
    dataIndex: 'Progress',
    key: 'Progress',
    width: 150,
  },
  {
    title: 'Score',
    dataIndex: 'Score',
    key: 'Score',
    align: 'right',
  },
  {
    title: 'Point Change',
    dataIndex: 'PointChange',
    key: 'PointChange',
    align: 'right',
  },
  {
    title: 'Percent Change',
    dataIndex: 'PercentChange',
    key: 'PercentChange',
    align: 'right',
  },
];

const demographicColumns = [
  {
    title: 'Category',
    dataIndex: 'Category',
    key: 'Category',
    fixed: 'left',
    width: 115,
    // colSpan: 2,
    render: (text, record) => {
      return (
        <div className="">
          <span style={{ fontWeight: 'bold', fontSize: '12px' }}>{text}</span>
        </div>
      );
    },
  },
  {
    title: 'Distribution of Responses',
    dataIndex: 'Distribution',
    key: 'Distribution',
    className: 'distribution-td',
    render: (text, record) => {
      return (
        <table className="distribution-table" style={{ width: 'unset' }}>
          <tr>
            {record.Distribution.map((item, index) => {
              return <td className="distribution-table-text">{item.Text}</td>;
            })}
          </tr>
          <tr className="dis-tr">
            {record.Distribution.map((item, index) => {
              return <td className="distribution-table-value">{item.Value}</td>;
            })}
          </tr>
        </table>
      );
    },
  },
];

class DashboardAnalytics extends Component {
  constructor() {
    super();
    this.state = {
      barSeries: [
        {
          name: 'Total Active',
          type: 'column',
          data: [8489, 9322, 10631, 11219, 12564, 13224],
        },
        {
          name: 'Newly added',
          type: 'line',
          data: [435, 833, 1309, 588, 1345, 660],
          // data: [1000, 3000, 6000, 9000, 12000, 15000]
        },
      ],
      barOptions: {
        plotOptions: {
          bar: {
            horizontal: false,
            dataLabels: {
              position: 'top',
            },
            columnWidth: '50%',
            // distributed: true
          },
        },
        chart: {
          height: 350,
          type: 'line',
          zoom: {
            enabled: false,
          },
          toolbar: {
            show: false,
          },
        },
        stroke: {
          width: [0, 4],
        },
        title: {
          text: 'Legacy . New',
        },
        dataLabels: {
          enabled: true,
          // enabledOnSeries: [1]
        },
        labels: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun'],
        xaxis: {
          type: 'category',
        },
        yaxis: [
          {
            title: {
              text: 'Total',
            },
          },
          {
            opposite: true,
            title: {
              text: 'Newly Added',
            },
          },
        ],
      },
      referralSeries: [],
      referralOptions: {
        chart: {
          width: 380,
          type: 'pie',
        },
        stroke: {
          width: 0,
        },
        legend: {
          show: false,
          // fontSize: '4px',
          // position: 'bottom',
          // horizontalAlign: 'center',
        },
        tooltip: {
          enabled: true,
        },
        labels: [], //mouse over text
        // colors: ['#2FBB7D', '#D85C5C', '#FFA800', '#4F99D2'],
        colors: [
          '#ff4000',
          '#ff8000',
          '#00bfff',
          '#0080ff',
          '#0040ff',
          '#0000ff',
          '#4000ff',
          '#ffbf00',
          '#ffff00',
          '#bfff00',
          '#8000ff',
          '#bf00ff',
          '#ff00ff',
          '#ff00bf',
          '#ff0080',
          '#ff0040',
          '#ff0000',
          '#80ff00',
          '#40ff00',
          '#00ff00',
          '#00ff40',
          '#00ff80',
          '#00ffbf',
          '#00ffff',
        ],
        responsive: [
          {
            breakpoint: 480,
            options: {
              chart: {
                width: 200,
              },
              legend: {
                position: 'bottom',
              },
            },
          },
        ],
      },
      // dddd
      treatmentSeries: [],
      treatmentOptions: {
        chart: {
          width: 380,
          type: 'pie',
        },
        stroke: {
          width: 0,
        },
        legend: {
          show: false,
        },
        plotOptions: {
          pie: {
            dataLabels: {
              offset: -10,
              minAngleToShowLabel: 20,
            },
          },
        },

        tooltip: {
          enabled: true,
        },
        labels: [], //mouse over text
        colors: ['#4F99D2', '#D85C5C', '#2FBB7D', '#1A45DF', '#FFA800'],
        responsive: [
          {
            breakpoint: 480,
            options: {
              chart: {
                width: 200,
              },
              legend: {
                position: 'bottom',
              },
            },
          },
        ],
      },
      seriesBubble: [
        {
          name: 'PROVIDER PERFORMANCE',
          data: [],
        },
      ],
      optionsBubble: {
        chart: {
          // height: 50,
          type: 'bubble',
          zoom: {
            enabled: true,
          },
          toolbar: {
            show: false,
          },
        },
        dataLabels: {
          enabled: true,
        },
        fill: {
          opacity: 0.8,
        },
        title: {
          text: 'at 60 days',
          align: 'right',
          style: {
            fontSize: '14px',
            fontWeight: 'normal',
            fontFamily: undefined,
          },
        },
        xaxis: {
          type: 'category',
          labels: {
            show: true,
            rotate: -45,
            rotateAlways: false,
            hideOverlappingLabels: true,
            showDuplicates: false,
            trim: false,
            maxHeight: 120,
            style: {
              colors: [],
              fontSize: '12px',
              fontFamily: 'Helvetica, Arial, sans-serif',
              fontWeight: 400,
              cssClass: 'apexcharts-xaxis-label',
            },
            offsetX: 0,
            offsetY: 0,
            formatter: value => {
              return `+${value}`;
            },
          },
          // max: 30,
          title: {
            text: 'Point Gained',
          },
          tickAmount: 4,
          // tickPlacement: 'between',
          min: 0,
          // max: undefined,
          // floating: false,
        },
        yaxis: [
          {
            labels: {
              show: true,
              align: 'right',
              minWidth: 0,
              maxWidth: 160,
              style: {
                colors: [],
                fontSize: '12px',
                fontFamily: 'Helvetica, Arial, sans-serif',
                fontWeight: 400,
                cssClass: 'apexcharts-yaxis-label',
              },
              offsetX: 0,
              offsetY: 0,
              rotate: 0,
              formatter: value => {
                return `${value}%`;
              },
            },
            axisBorder: {
              show: true,
              // color: '#78909C',
              offsetX: 0,
              offsetY: 0,
            },
            title: {
              text: '% Increased',
            },
            tooltip: {
              enabled: false,
            },
            crosshairs: {
              show: false,
            },
          },
        ],
        plotOptions: {
          bubble: {
            minBubbleRadius: 10,
            maxBubbleRadius: 60,
          },
        },
      },
    };
  }


  getReportId = () => { 
    var param = new URLSearchParams(this.props.history.location.search);
    var reportId = param.get('report-id');
    if (reportId) {
      reportId = parseInt(reportId);
    } else {
      reportId = null;
    }
    return reportId;
  }


  componentDidMount() {
    const { dispatch } = this.props;

    dispatch(
      getEmbedInfo({
        Json: JSON.stringify({
          AnalyticReport: [
            {
              AnalyticReportId: this.getReportId() || null,
            },
          ],
        }),
      }),
    );
  }

  componentWillReceiveProps(props) {
    if (props.activeClientData[0]) {
      let Months = props.activeClientData[0].ActiveClientGraph[0].Months;
      Months = Months.substr(1, Months.length - 2).split(',');
      let NewlyAdded = props.activeClientData[0].ActiveClientGraph[0].NewlyAdded;
      NewlyAdded = NewlyAdded.substr(1, NewlyAdded.length - 2).split(',');
      let TotalActiveInMonth = props.activeClientData[0].ActiveClientGraph[0].TotalActiveInMonth;
      TotalActiveInMonth = TotalActiveInMonth.substr(1, TotalActiveInMonth.length - 2).split(',');
      let barSeriesFirst = { ...this.state.barSeries[0], data: TotalActiveInMonth };
      let barSeriesSecond = { ...this.state.barSeries[1], data: NewlyAdded };
      let newBarSeries = [barSeriesFirst, barSeriesSecond];
      this.setState({
        barOptions: { ...this.state.barOptions, labels: Months },
        barSeries: newBarSeries,
      });
      // console.log(props.activeClientData[0].ActiveClientGraph[0]);
      // let aData = props.activeClientData[0].ActiveClientGraph;
      // let b = aData[0].Months.slice(0, aData[0].Months.length);
    }
    if (props.demographicClientData != this.props.demographicClientData) {
      let keys = Object.keys(props.demographicClientData);
      let demodata = [];
      keys.map(key => {
        return demodata.push({
          Category: key,
          Distribution: props.demographicClientData[key],
        });
      });
      this.setState({
        demographicClient: demodata,
      });
    }
    if (props.triggerLocationActivity.length > 0) {
      let data = [];
      props.triggerLocationActivity.map((item, index) => {
        return data.push({
          [item.Triggerheader]: item.TriggerValue,
          IsBold: item.IsBold,
        });
      });
      this.setState({
        triggerLocationActivity: props.triggerLocationActivity,
      });
    }
    if (props.ReferralSource.length > 0 && props.ReferralSource != this.props.ReferralSource) {
      let Labels = [];
      let ReferralCount = [];
      let ReferralCountPercent = [];
      props.ReferralSource.map(source => {
        Labels.push(source.Description);
        ReferralCount.push(source.ReferralCount);
        ReferralCountPercent.push(source.ReferralCountPercent);
        return;
      });
      this.setState({
        referralSeries: ReferralCount,
        referralOptions: { labels: Labels },
        ReferralCountPercent,
      });
    }
    if (props.timeInTreatment.length > 0 && props.timeInTreatment != this.props.timeInTreatment) {
      let Labels = [];
      let Total = [];
      props.timeInTreatment.map(source => {
        Labels.push(source.TimeInProgram);
        Total.push(parseInt(source.Total));
        return;
      });
      Total.pop();
      Labels.pop();
      this.setState({
        treatmentSeries: Total,
        treatmentOptions: { labels: Labels },
      });
    }
    if (
      props.ProviderPerformancePercentage &&
      props.ProviderPerformancePercentage.length > 0 &&
      props.ProviderPerformancePercentage != this.props.ProviderPerformancePercentage
    ) {
      let Data = [];
      props.ProviderPerformancePercentage.map(item => {
        Data.push([item.PositiveScore, item.PositivePercentage, item.ClientCount]);
        return;
      });
      this.setState({
        seriesBubble: [
          {
            name: 'at 60 Days',
            data: Data,
          },
        ],
      });
      //       data: [
      //   [0, 0, 10],
      //   [5, 5, 30],
      //   [15, 5, 60],
      //   [10, 10, 75],
      //   [10, 2, 100],
      //   [15, 18, 300],
      // ],
    }
  }
  handleProviderChange = providerValue => {
    this.setState({ providerValue });
  };
  handleProgramTypeChange = programTypeValue => {
    this.setState({ programTypeValue });
  };
  render() {
    const {
      servicesDelivered,
      timeInTreatment,
      isFetching,
      categoryClientData,
      standardCostOfCare,
      demographicClientData,
      totalStandardCostOfCare,
      SPBehavioralRating,
      ScoreImprovement,
      ProviderPerformance,
      // triggerLocationActivity,
      serviceDelivered,
      ActiveClient,
      UnitsOfServiceDelivered,
      ClientInteraction,
      ReferralSource,
      centerProgramType,
      center,
      defaultCenter,
      powerBI,
    } = this.props;
    const {
      barSeries,
      barOptions,
      demographicClient,
      triggerLocationActivity,
      referralSeries,
      referralOptions,
      treatmentSeries,
      treatmentOptions,
      seriesBubble,
      optionsBubble,
      providerValue,
      programTypeValue,
    } = this.state;
    return (
      <div>
        <PageTitle TitleText="Power BI" />
        <Loader loading={isFetching} />
        <div class="container-fluid dashboard-analytics">
          {/* <button
            className="btn table-btn mb-1"
            onClick={() => {
              this.props.history.push('/dashboardAnalytics');
            }}
          >
            Back to Dashboard
          </button> */}
          {/* <Link to="/dashboardAnalytics" class="back-link">
            <img src="images/back-arrow.svg" /> Back
          </Link> */}

          {/* <div className="d-flex justify-content-between align-items-center"> */}
          <div className="row align-items-center d-none">
            <div className="col-3">
              <h5 class="card-title mr-1">Client Group : </h5>
              <div class="form-group">
                <Select defaultValue="active" style={{ width: 100 }} disabled>
                  <Option value="active">Active</Option>
                  <Option value="in-active">In-active</Option>
                </Select>
              </div>
            </div>
            <div className="col-6 enrollment-form">
              <div className="row dashboard-analytics-centers">
                <div class="col-6">
                  <div class="form-group">
                    <ReduxSelect
                      options={center}
                      onChange={this.handleProviderChange}
                      className="basic-single"
                      classNamePrefix="select"
                      // value={defaultCenter}
                      value={providerValue}
                      placeholder="Provider"
                      disabled
                    />
                  </div>
                </div>
                <div class="col-6">
                  <div class="form-group">
                    <ReduxSelect
                      options={centerProgramType}
                      onChange={this.handleProgramTypeChange}
                      className="basic-single"
                      classNamePrefix="select"
                      value={programTypeValue}
                      placeholder="Program Type"
                      disabled
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="col-3"></div>
          </div>

          {/* <div class="card" style={{ position: 'inherit' }}>
            <div class="card-body"> */}
          {/* <br />
          <br />
          <h5 class="card-title">MAPPING</h5> */}
          {/* <p>
                  <div className="row mb-2">
                    <div className="col-md-6">
                      <Checkbox className="mr-1" /> Trigger Location
                    </div>
                    <div className="col-md-6">
                      <Checkbox className="mr-1" />
                      Stage of Treatment
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-6">
                      <Checkbox className="mr-1" />
                      Substance Type
                    </div>
                    <div className="col-md-6">
                      <Checkbox className="mr-1" />
                      City, Country and Zip Code
                    </div>
                  </div>
                </p> */}
          <div>
            <PowerBIEmbed
              embedConfig={{
                // type:  powerBI && powerBI.type,
                type: 'report', // Supported types: report, dashboard, tile, visual and qna
                embedUrl: powerBI && powerBI.embedUrl && powerBI.embedUrl.embedUrl,
                accessToken: powerBI && powerBI.accessToken,
                tokenType: models.TokenType.Embed,
                settings: {
                  panes: {
                    filters: {
                      expanded: false,
                      visible: false,
                    },
                    pageNavigation: {
                      visible: true,
                      position: models.PageNavigationPosition.Left,
                    },
                  },
                  background: models.BackgroundType.Transparent,
                },
              }}
              eventHandlers={
                new Map([
                  [
                    'loaded',
                    function() {
                      console.log('Report loaded');
                    },
                  ],
                  [
                    'rendered',
                    function() {
                      console.log('Report rendered');
                    },
                  ],
                  [
                    'error',
                    function(event) {
                      console.log(event.detail);
                    },
                  ],
                  [
                    'onClick',
                    function(event) {
                      console.log(event.detail);
                    },
                  ],
                ])
              }
              cssClassName={'report-style-class-fullView'}
              getEmbeddedComponent={embeddedReport => {
                console.log(`Embedded object of type "${embeddedReport.embedtype}" received`);
                this.setState({ report: embeddedReport });
              }}
              // onClick={() => {}}
            />
            {/* <PowerBIEmbed
                    embedConfig={{
                      type: 'report', // Supported types: report, dashboard, tile, visual and qna

                      embedUrl:
                        'https://app.powerbi.com/reportEmbed?reportId=7def3bb6-c350-4377-b800-f0f19782a60c&groupId=ec0de48e-3205-4545-882a-388339cb59bc&w=2&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly9XQUJJLUlORElBLUNFTlRSQUwtQS1QUklNQVJZLXJlZGlyZWN0LmFuYWx5c2lzLndpbmRvd3MubmV0IiwiZW1iZWRGZWF0dXJlcyI6eyJtb2Rlcm5FbWJlZCI6dHJ1ZX19',
                      accessToken:
                        'H4sIAAAAAAAEACWURa7DVgAA7_K3rmSI4aVSF2ZmiO2dKYkZnrnq3fvV7mc1Gs3fP052dWNW_vz50zeYS2j1lOUHtSyx5BgclFcjWYW2-saNeklw38LgTGJLoQF7SIv54coX4ue2fGDr53qgajwYx_fw12NyGiB8s3DobsRuk_0zPPsnEe6zyRL5mlNp2s2KpTHEObJkoZ1RtVymQSAhjSqR7EXHFUysJbPahsHk8O1PL89OQMiHq_XxNpYkXgDW2BIDMXNLs-93OukQDT1ppgpl9wAfIkUcY6vno5cwtW220ptrGH4mcV7Gk07ZeKeRPZGBM2qyNpOWkWDRaZ6ly5quMIDBWRbwX2Fhtsk1Tf98V0RdhsR1MS_CKexG4yLI-VkpuxLZvHDuHUTuFj-HV1g_6ZdjtQ5-3OWbvJGte2JlYDlP0OCn3qpwRJgK4LrQoAF7QjtpNjtPFG7pr6fjRVDoVOFMoaw-O-jZWl9oPMPm1li510XIDgmYnKfxYeBt6y1JtZ9NzbARJRkvUueWXSZK5Gd5wlrg7lrWs6XagDjGDrEFiz7jXsPjfTCQ1Heshl7RdZ2AwJ3dmYMNCK_yy6CyzRGV1AU-SzW-BKDTVzBz5F7UuwaPrXu7qpBcZKhAQE8DFN3q1H0PZKcHUTf9-BXOcX2lgP1ldBMT3LN9cD0vIi0gUjixw8FJQsDV6nx-8lh01FfBoYFVvnlnDCNGw4ajDXmsyu7AsU1hfYwDgEigS5goTa3BPY7WkU3n20lJEWfLhbJA1KwqURRk3DoqzOSWa9cgnw2ZEHqH8Z7BFViiStF0GqWZva_HXz9__PDLNa2jXl2_6QcfdJan75kR51cVs54XYmxOZc96Myi3d2jP0qiYJFOZG1Es4rlel1hPr2VVzKfbtE7uSQGlhjoS7PqJvXv_8TjjBfUTbg4WmrFd4mVjStxxiIQgZbqAL3yoHIPfZyPlclHd2y3rkJY47dwDPnTxs6ImlglBPkhzH1689RKcglQkZZ5TnC2_E4Kx9m1yhLvG-Gkszi7et-l2E0CxqgdDRheZr04rm6-U3NaEL3c6JI-BxWOoFX5f7TYs1kl472_Jo285mTSXTuPanDERXA-FXq_MB9X4kqfkeAk-7LLjOY9auXG_6d-UMjFKx23U8uwyelTPl3Bvvk7M2LjozOPgePmmjr_-03xN32pRo1_LrTEjK57SMX3Znhev-_p-If9Tfv0ZsnVbql9sIg8h5DKcJQns1I6U8kFKzCPjwMelUScGyzO3MB2k73IAnkCDRTQNupDKqQgq-qAOu7fdaDxgqH6MU266EUUYm4h9quZL-ut2jia5b1arjmGOdN-ya1X3Z12xmHdhQcTVQRSETjq7tURvGZSNRw0ONLyeiHaZS-hasTW25w6j4lIgHdXzNRxurCH7d7zVW-gvKoII_KrC1e7a0sl1gu_roPksJGH4eGw1wELieEjhEVRrV4t7Vq4DTW3yu_dMSZH9xEF0GktFel-Zyss-z_alKovnCIhm41hD-2ruagM5XtvZMvLUrU1W_Y4u2ap6jFIQ3VSsz8sy6GYrig8Gt1X2yf5q_udfTEzZGu4FAAA=.eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly9XQUJJLUlORElBLUNFTlRSQUwtQS1QUklNQVJZLXJlZGlyZWN0LmFuYWx5c2lzLndpbmRvd3MubmV0IiwiZW1iZWRGZWF0dXJlcyI6eyJtb2Rlcm5FbWJlZCI6ZmFsc2V9fQ==',
                      tokenType: models.TokenType.Embed,
                      settings: {
                        panes: {
                          filters: {
                            expanded: false,
                            visible: false,
                          },
                        },
                        background: models.BackgroundType.Transparent,
                      },
                    }}
                    eventHandlers={
                      new Map([
                        [
                          'loaded',
                          function() {
                            console.log('Report loaded');
                          },
                        ],
                        [
                          'rendered',
                          function() {
                            console.log('Report rendered');
                          },
                        ],
                        [
                          'error',
                          function(event) {
                            console.log(event.detail);
                          },
                        ],
                      ])
                    }
                    cssClassName={'report-style-class'}
                    getEmbeddedComponent={embeddedReport => {
                      console.log(`Embedded object of type "${embeddedReport.embedtype}" received`);
                      this.setState({ report: embeddedReport });
                    }}
                  /> */}
            {/* <img
                    src={`images/NewdashboardMap.png`}
                    alt="map"
                    usemap="#analyticsMap"
                    width="400"
                    // height="566"
                  />
                  <map name="analyticsMap">
                    <area
                      shape="rect"
                      coords="1,1,400,620"
                      //   coords="2790,2239,1914,892"
                      alt="Computer"
                      target="_blank"
                      href="https://app.powerbi.com/groups/me/reports/74bc8346-04a0-4a2a-b262-f6f707691905/ReportSection"
                    />
                  </map> */}
          </div>
          {/* </div>
          </div> */}

          <div className="col-md-12">
            {/* <PowerBIEmbed
              embedConfig={{
                type: 'tile', // Supported types: report, dashboard, tile, visual and qna

                id: 'e9c81853-3263-4f30-af4b-63fad7d79627',
                dashboardId: 'b5f50796-6e97-4dc5-a755-00cf4405e029',
                embedUrl:
                  'https://app.powerbi.com/embed?dashboardId=b5f50796-6e97-4dc5-a755-00cf4405e029&tileId=e9c81853-3263-4f30-af4b-63fad7d79627&groupId=be8908da-da25-452e-b220-163f52476cdd&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly9XQUJJLVVTLU5PUlRILUNFTlRSQUwtcmVkaXJlY3QuYW5hbHlzaXMud2luZG93cy5uZXQiLCJlbWJlZEZlYXR1cmVzIjp7Im1vZGVybkVtYmVkIjpmYWxzZX19',
                accessToken:
                  'H4sIAAAAAAAEACWWtc7FXJZE3-VPPZKZRurAzMzOTNfM7Na8-3zqjs-O1qkqrX__Y2fvMGflP__7z-b-jt-G9TttKYfQa2uAKKMljGOt8hTasrM8SutzKk_ILMovunJTWeDcxWXMQGRDolVdLyuUdyUUf6Nz4IIcCfvc4UnhIxaXPSs8ktzv5Oip65yViaMfMQ61hwSgpTzj5U_vbTgsTq4db-Ov-YTueKHZaZa_bplEo38wEemUx7wlNjACOVouHA8xafhZT_ZiZmiFTu_G8dovbL3oU3nD-O4buAyr0AwOvU9et2vmlSXBib6wuV3Euf5RI-H_SLnk-1hS0pyKaVp3W_ue7fE6qUJLWn0xY4hnRsVIAU8EwqM3j48JWwneno2aVhC-FS6OdHZsAMzWsIPD1A_LwLoHG5AuS8edOPkbXfniRQECpHGcQXgVYka_sR-MUqSh7Wa8cbznbJKqc-h9fZBbT7iNKLELmUV9UHY77ncRpjYqaUdb0WWD9S7JCLQ-O7KbKyD5HgJFn7HUhQG6NGNmDhet_sDMq3PsRV0_nj5M5-ndUX9ZHRUyHlOC701-FtC4kndGkpBMqhRgCuDmJRUD0qjht-HET3WX4i17xvBWcSK-BvTRPWM97o04n1sIR_nOFLjFbP-JJ9oBNVDtbPj8pOfs7SZnJa9WNGTuj6ejDMt32KXlQ587rwzoa9brLOSxBR5XYieFVHFTrdCoCdY-G71LuRG40QS4LBF7LaFCS7wgQH8Urda1Gh_XHnydEGkgx_6KdMks2zNksodTOynIwqvlBIHPShx5mlKGzyZ1ht_mTbb_wLkT85TReD5DfwT81dlG5Iowtt3BxVznATAsXtBVVXKN11dUO-IHmEv6QD9KgkuoVI8SZBjFqh_6t5YULunjS4OOZ73PNaJminKgUyBGmQAA1o3FftzNaDz2lpTzUZBFDi04m2u-w6FGZ-9hd0hhAjCnHWvdIBagJ7xbpWhOnzdZDTdXu1Ze8TuJRRWi5tdLHiZPXh_ipM89NNh9IwOkS8cz9-0grwfzzioqxBhHKlEhe_dT3k1tRxLiOD0ViZ7AxcE4lxtHKkb3jpxkTCXCl1d2W5NTaO-ZHyQ6tQvx4qA0GAN1FhNOKPGjTrQYEtCUUNlBQuELRA4XhmVBCX69L6pI6rN6zxxu5b8P4xa98oWEyxn9XAkPOt7UypEP6ZHxnTP-Uy1khywgIOhDh51984pP19Eg3xIoR5JxQh2EpYLZNrWUCBK728dPb2MEzF31r5-9FgCO1Ayn9lloAVf6UiEgAW99aRF-cE3gDTLN0s1OqxZFrn2aCA41MkXA3KjiiT1lBDjBR7JL-gsgt-2FqjNgrAT8Whf2kVcPbPQJmUz56g5Es334Mf75BEE0d8V5qMR1d-N3wHSGwt8j1z_6970HZHG5xo0vOzk-5YuEkGVHUgL1Q3TksJFvGR8uniaYOw2vkvgVnTnFbIX21GzqEMNFnJwlkrUC1kZDCeLe6OZHcT-XilWcsXdGCXyW-lcbrCgSdtVQR8jL26br_Mo44281-HRe5f5evJ9cYjpoE_NxvXqs1ZLn04vI3Hw2iKFGR4MmAaiKX11g50fTKck-_zqiQSlXRNZkvlyTXqfJS5RwcVsQji4q0txKwiln8Msl-MXzrM3WLt8SJGXER69_ZFNRe6ryruj8sK6pgxcNj9RoJJlewOpdUDRsaVUNxIp6gJZLqo_yHXhYdiPgeLKAz4jRhiJTV6nPYJtiFFeZe6ilrh0fBUFqtYmXLZ3sKofVnlzASKGUfQV0l8ZyN8j6bCOM_COHJLDUMWSx2LHgu9ouq8O4qOMNQHoYI1OuyGRjOCPrsn9zoZBXZEGAHT5A0t2jDA-KBDf7IMHw-nxId2nfHhj6w7ryE9SThXIDqzdYOuY-kd5xlaRCH4MzRfgnkEFwpph_6XlpypPA1Hdhb5nkGN2UsmaSEqk5UcFKecu_srkAIEaC8pY7wJtHOxfzv6UkRrX_i77NK4TiiZXvv22v_Ej8I9oJlKwiAasJLxm2TS-aWXN3IVc7AmAlH3tA4SjR74npKo0VLi_4gUJX7hYFCrbg5g7BV8JayvW4_TxoFdok0PwhV4nipy4yhyUeiW2WQBAGzqjA8jIrl2cVIoGy2YcrZc7CouZRMhblWRUZl4E7hMtn0gG3zGrQs8KSkm3yrze3UFGO-dYJ-EhAp4_8c7o584yovQgo_EtaWhgcQKZKZzEczmIg3ePQYJy6r6ukvwFUKSNCfxFHy-epnb99tOgyzTL3646jdfDr886qLgvxCA0rxQznAXsKYrwc_1EQ6NwM6bHVM3NsQxTmefCBEYmlQNozg_B_MXprz3f2Hl04ixpcz_Zm-fvp4nY_I_TwnXsxPVb4x4EJuv-FVY7RB6P9eN_9ha9N1ca0t83MnC5HLLpyWsJVTrL7TA2Z0ClrCPVII2SWRQ9zeOejh0uudlgpfM7yp09X5mHEglsKopMMhM31v_75n3-47V2OWaveP_XqHXzu2vHrRyGiqklWceYdI3AprbMx6oqOxallrn0vmyO-iYdLeTaToebNOgRYJu466B1yVZaETehc7R3azh6NvznB59DaGO14eJhWjfPiQr54EMjo9fRE2rtru79NlTvGvwlOBW8GNjczov2AJVh0tqabT_gCPjtK35MCfhZzqA-95wBZl9I1PVcYRmMNBsACMqV-0-LMrwgqgt4QBtOVtMAjc1cOCeY0iEQjfVbmHu7cYl_-L3xSH203UZ8n5n3S_qcmXcw5FcIU8eaS6bRKAs_i1ktw7LX6mxvigw2MJgepsqLuWVGLqqBzfm2-ilpKkNkBHCbTcI4x54X6F0WtifOv_2B-l6balPCP8lulkj2hcNcVpqOo28uAWPPfK6-tp-w4t-rv7Bwj7zpipTzLdM1DUBMI0iYF7wXyTBf9IB5Bpyq1a9V70o0NsNJ8lMT_dJnJKhCwZCNhdUO1PkKK1iDS4gD8oYD57HHd8KhuKyHH4DyNQDcbNGsxUAAGXQeA_6rNFhrqbF8g2CR9Az_itBtkVNtQXpVvj5FjbsmUIlpJnYCKlNeC25ahO4xqb4oFbd9N12lDSjrVSA-GhxEsWzY-z5m2I1lUV1WlRhTQpKRfFgtvydf0gb6jD4uYYGncyg2TMB1TcoLz4Jrmn759TMO0ij61vymMtvoqKnb3MBaomGjbUs1VgrTO6gmadY2ZbYsZ2E4Tevcp3cUdfVTzaufLVfivE89e_2H-v_8HAM-OVm4MAAA=.eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly9XQUJJLVVTLU5PUlRILUNFTlRSQUwtcmVkaXJlY3QuYW5hbHlzaXMud2luZG93cy5uZXQiLCJlbWJlZEZlYXR1cmVzIjp7Im1vZGVybkVtYmVkIjpmYWxzZX19',
                tokenType: models.TokenType.Embed,
                settings: {
                  panes: {
                    filters: {
                      expanded: false,
                      visible: false,
                    },
                  },
                  background: models.BackgroundType.Transparent,
                },
              }}
              eventHandlers={
                new Map([
                  [
                    'loaded',
                    function() {
                      console.log('Report loaded');
                    },
                  ],
                  [
                    'rendered',
                    function() {
                      console.log('Report rendered');
                    },
                  ],
                  [
                    'error',
                    function(event) {
                      console.log(event.detail);
                    },
                  ],
                ])
              }
              cssClassName={'report-style-class'}
              getEmbeddedComponent={embeddedReport => {
                console.log(`Embedded object of type "${embeddedReport.embedtype}" received`);
                this.setState({ report: embeddedReport });
              }}
            /> */}

            {/* <PowerBIEmbed
              embedConfig={{
                type: 'tile', // Supported types: report, dashboard, tile, visual and qna
                tokenType: models.TokenType.Embed,
                accessToken:
                  'H4sIAAAAAAAEAB1WRQ7sCA69y99mpHBSGakXqTAz7sLMnNbcfa…lbWJlZEZlYXR1cmVzIjp7Im1vZGVybkVtYmVkIjpmYWxzZX19", TokenId: "078f4fff-1dc4-4592-b1e0-b82863ee49f2", Expiration: "/Date(1606099370000',
                embedUrl:
                  'https://app.powerbi.com/embed?dashboardId=b5f50796-6e97-4dc5-a755-00cf4405e029&tileId=e9c81853-3263-4f30-af4b-63fad7d79627&groupId=be8908da-da25-452e-b220-163f52476cdd&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly9XQUJJLVVTLU5PUlRILUNFTlRSQUwtcmVkaXJlY3QuYW5hbHlzaXMud2luZG93cy5uZXQiLCJlbWJlZEZlYXR1cmVzIjp7Im1vZGVybkVtYmVkIjpmYWxzZX19',
                id: 'e9c81853-3263-4f30-af4b-63fad7d79627',
                dashboardId: 'b5f50796-6e97-4dc5-a755-00cf4405e029',

                settings: {
                  panes: {
                    filters: {
                      expanded: false,
                      visible: false,
                    },
                  },
                  background: models.BackgroundType.Transparent,
                },
              }}
              eventHandlers={
                new Map([
                  [
                    'loaded',
                    function() {
                      console.log('Report loaded');
                    },
                  ],
                  [
                    'rendered',
                    function() {
                      console.log('Report rendered');
                    },
                  ],
                  [
                    'error',
                    function(event) {
                      console.log(event.detail);
                    },
                  ],
                ])
              }
              cssClassName={'report-style-class'}
              getEmbeddedComponent={embeddedReport => {
                console.log(`Embedded object of type "${embeddedReport.embedtype}" received`);
                this.setState({ report: embeddedReport });
              }}
            /> */}

            {/* <PowerBIEmbed
              embedConfig={{
                type: 'report', // Supported types: report, dashboard, tile, visual and qna

                embedUrl:
                  'https://app.powerbi.com/reportEmbed?reportId=ffd96ae6-d380-4b0a-b892-9b10c1ccb332&groupId=c01c3203-966c-4a73-a8a9-50b6f9cc8bc8&w=2&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly9XQUJJLVVTLU5PUlRILUNFTlRSQUwtcmVkaXJlY3QuYW5hbHlzaXMud2luZG93cy5uZXQiLCJlbWJlZEZlYXR1cmVzIjp7Im1vZGVybkVtYmVkIjp0cnVlfX0%3d',
                accessToken:
                  'H4sIAAAAAAAEAB2Ut66EVgAF_-W1WCIvYMkFcQmXtKSFjpxzxvK_-9n9VHNG5-8fK767Mc5-_vxxQh_BVggv0-9759OZbZA4ffi9vAvfFjBnsx-fFcKRQNFu3K-lIM5bBqMLw87V85trs9wxLYXUNuaDOYRPE6n-FGFsfpyH8-EzNtFTeKzlnF4f3Ll1aWEXTY_B9mCQGz-RyeV-nEkUpjfj22H24_5ugYrJsk748FZzBKwoTtdaY-rpuJq1DDc34u6xILcIsOi95hMknWnuQKkXoOS46dWEqwm11cBo32MYS_UMYo0XDTUCiM55bd2CrDBLENjqVAjLFh4oQJPYiXKE5iVqrQJmKHJedcXgSTgqvvC9e9GK6DUGbpCFzrHGSn1pUcjjSrDfk9Z8aofEqNaIw7EIX8vB6wA83zRtHBcIFxM0ciuWTNRVdMqF0F3gb_dE65A4ZF9X0jCji9zpMaeSzSKyQuZLT_ha5fXDw8TgvA9MRbXXGmPnOB9ixDAqL6aAyoY7v078kt2PTf16dIMmcDamsO1ZJNzrPeyk0qM056lHbVMBPRIdr2SykpuasOd6ftU0LE_8LOV4TfuI2KMaXIUF_3qrnzzUH-1Q-onN_Hr1Xe0OKKAd1Imbmro6Uf1SJZptjJhfrCnMeiVXTb-Bz8PTuMsyZxAsL5lPPpdnstkE2UvTrm605gw780VcrCSnWsaDB1Ett3vFy4LWW0gRQ0Lr8xOfkhyM4ytnw8cd0I5AtJgtwqP4188fP_xyT9uo5fdvutYHDJzcvnCnwEqe3jFtzFppdFzBls0aIfuPhvJmFJT9cgtCVm_TknKss-3P3mvdHe09CPFFXurURb-3KbzuIYNUZLlgaA3BUqtxKenwoMDs4wIubRNib509mZePc5GpPlHrnMN89MkaPvEMHGeRQu4kNpESxdivd1xBjDKvAVZJ8Sh9WmD4w52Okx1328BkGJR3PAplDZ09X_-mpkFPT984UBWpy4I0M5Z_4ETaJcg3DAszMCfhOfsdcWG-j9NCW6On-lLVe-3KR35_ZagfEGtvmUKHiOW01zXNru-NORkBrDcyYLzRHbeSvmu3yI7O8qphachGLtnHt9ptTBXRopyy_Ot_zfdU5Yvi_1qW8kZPowDrtXcSYgGwWP-Uzv8ppy6HeNuX_BcbAtFAUBJfrjCItNauFcLs8PMtqfQCelDwXoTBRp0Q0NaGQVC8Z3jrHIpWnGg_KpCmBoE2WvZMM6cnQR_lm6V5k3HbUPSyF-ajBEzaWdEO5CZffSLf8DUzoIBPJyN_6tMsXlui5m6kcknZUx1i1s9D5ab1Il5Y5UKknv9-z5eaQwXqCZsK9zKjZQyu1SLosjSoAkl6PkIz2eRLIDxMq_qxdb_hfYLaHqOJj2vADHPjFqZB4NcoeUrbz4DUMzQV2iL3DSRZRw-yheqyWVa0ZfwtFBBlK1L3abkjcL5aEoTdbQfdYRYZIr_ycahswS4HhT4XesVqQhA1v2fIXacqqm4_JPTfGP_8C4-QbFauBQAA.eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly9XQUJJLVVTLU5PUlRILUNFTlRSQUwtcmVkaXJlY3QuYW5hbHlzaXMud2luZG93cy5uZXQiLCJlbWJlZEZlYXR1cmVzIjp7Im1vZGVybkVtYmVkIjpmYWxzZX19',
                tokenType: models.TokenType.Embed,
                settings: {
                  panes: {
                    filters: {
                      expanded: false,
                      visible: false,
                    },
                  },
                  background: models.BackgroundType.Transparent,
                },
              }}
              eventHandlers={
                new Map([
                  [
                    'loaded',
                    function() {
                      console.log('Report loaded');
                    },
                  ],
                  [
                    'rendered',
                    function() {
                      console.log('Report rendered');
                    },
                  ],
                  [
                    'error',
                    function(event) {
                      console.log(event.detail);
                    },
                  ],
                ])
              }
              cssClassName={'report-style-class'}
              getEmbeddedComponent={embeddedReport => {
                console.log(`Embedded object of type "${embeddedReport.embedtype}" received`);
                this.setState({ report: embeddedReport });
              }}
            /> */}
          </div>
        </div>

        {/* <div class="container-fluid mt-5">
          <div className="row">
            <div className="col-md-4">
              <div className="tile">
                <h5 class="card-title">SERVICES DELIVERED</h5>
                <Table
                  dataSource={servicesDelivered}
                  columns={servicesDeliveredColumns}
                  bordered
                  pagination={false}
                />
              </div>
            </div>
            <div className="col-md-4">
              <div className="tile">
                <h5 class="card-title">SERVICES DELIVERED</h5>
                <Table
                  dataSource={servicesDelivered}
                  columns={servicesDeliveredColumns}
                  bordered
                  pagination={false}
                />
              </div>
            </div>
          </div>
        </div> */}
      </div>
    );
  }
}
const mapStateToProps = ({
  combos,
  default_values,
  get_Analytics,
  get_active_client,
  get_category_client,
  get_client_demographic,
  get_cost_of_care,
  get_behavioral_rating,
  get_score_improvement,
  get_provider_performance,
  get_Trigger_Location_Activity,
  get_Service_Delivered,
  get_referral_source,
  get_embed_info,
}) => {
  const { data, isFetching, error } = get_Analytics;
  const {
    data: activeClientData,
    isFetching: isFetchingActive,
    error: ActiveError,
  } = get_active_client;
  const {
    data: categoryClientData,
    isFetching: isFetchingCategory,
    error: CategoryError,
  } = get_category_client;
  const {
    data: demographicClientData,
    isFetching: isFetchingDemographic,
    error: DemographicError,
  } = get_client_demographic;
  const {
    data: costOfCareData,
    isFetching: isFetchingCostOfCare,
    error: CostOfCareError,
  } = get_cost_of_care;
  const {
    data: behavioralRatingData,
    isFetching: isFetchingBehavioralRating,
    error: BehavioralRatingError,
  } = get_behavioral_rating;
  const {
    data: scoreImprovementData,
    isFetching: isFetchingScoreImprovement,
    error: ScoreImprovementError,
  } = get_score_improvement;
  const {
    data: providerPerformanceData,
    isFetching: isFetchingProviderPerformance,
    error: ProviderPerformanceError,
  } = get_provider_performance;
  const {
    data: triggerLocationData,
    isFetching: isFetchingTriggerLocation,
    error: TriggerLocationError,
  } = get_Trigger_Location_Activity;
  const {
    data: serviceDeliveredData,
    isFetching: isFetchingServiceDelivered,
    error: ServiceDeliveredError,
  } = get_Service_Delivered;
  const {
    data: referralSourceData,
    isFetching: isFetchingReferralSource,
    error: ReferralSourceError,
  } = get_referral_source;
  const { data: powerBiData, isFetching: isFetchingPowerBi, error: powerBiError } = get_embed_info;

  let CategoryClientData = [];
  let ServicesDelivered = [];
  let TimeInTreatment = [];
  let ActiveClientData = {};
  let DemographicClientData = {};
  let StandardCostOfCare = [];
  let TotalStandardCostOfCare = [];
  let SPBehavioralRating = {};
  let ScoreImprovement = [];
  let ProviderPerformance = [];
  let TriggerLocationActivity = [];
  let ServiceDelivered = [];
  let ActiveClient;
  let UnitsOfServiceDelivered;
  let ClientInteraction;
  let ReferralSource = [];
  let ProviderPerformancePercentage = [];
  let centerProgramType = [];
  let defaultCenter = [];
  let center = [];
  let powerBI = {
    embedUrl: '',
    accessToken: '',
    type: '',
  };

  if (combos.data) {
    const { CenterProgramType, Center } = combos.data;
    if (CenterProgramType) {
      centerProgramType = CenterProgramType;
    }
    if (Center) {
      center = Center;
    }
  }
  if (default_values && default_values.data) {
    // debugger;
    defaultCenter = default_values.data.centerId;
  }
  if (data) {
    ServicesDelivered = data.ServicesDelivered;
    TimeInTreatment = data.TimeInTreatment;
  }
  if (activeClientData) {
    ActiveClientData = activeClientData;
  }
  if (categoryClientData) {
    CategoryClientData = categoryClientData.CategoryClient;
  }
  if (demographicClientData) {
    DemographicClientData = demographicClientData || {};
  }
  if (costOfCareData) {
    StandardCostOfCare = costOfCareData.StandardCostOfCare;
    TotalStandardCostOfCare = costOfCareData.TotalStandardCostOfCare;
  }
  if (behavioralRatingData) {
    SPBehavioralRating = behavioralRatingData;
  }
  if (scoreImprovementData) {
    ScoreImprovement = scoreImprovementData.ScoreImprovement;
  }
  if (providerPerformanceData) {
    ProviderPerformance = providerPerformanceData.ProviderPerformance;
    ProviderPerformancePercentage = providerPerformanceData.ProviderPerformancePercentage || [];
  }
  if (triggerLocationData) {
    TriggerLocationActivity = triggerLocationData.TriggerLocationActivity;
  }
  if (serviceDeliveredData) {
    ServiceDelivered = serviceDeliveredData.ServiceDelivered;
    ActiveClient = {
      ActiveClient: serviceDeliveredData.ActiveClient,
      ActiveClientAppUser: serviceDeliveredData.ActiveClientAppUser,
      ActiveClientInPatient: serviceDeliveredData.ActiveClientInPatient,
    };
    UnitsOfServiceDelivered = serviceDeliveredData.UnitsOfServiceDelivered;
    ClientInteraction = serviceDeliveredData.ClientInteraction;
  }
  if (referralSourceData) {
    ReferralSource = referralSourceData.ReferralSource;
  }
  if (powerBiData && powerBiData.result) {
    powerBI.embedUrl = powerBiData.result.embedReport[0];
    powerBI.accessToken = powerBiData.result.embedToken.token;
    powerBI.type = powerBiData.result.type;
  }
  return {
    servicesDelivered: ServicesDelivered || [],
    timeInTreatment: TimeInTreatment || [],
    isFetching:
      isFetching ||
      isFetchingActive ||
      isFetchingCategory ||
      isFetchingDemographic ||
      isFetchingCostOfCare ||
      isFetchingBehavioralRating ||
      isFetchingScoreImprovement ||
      isFetchingProviderPerformance,
    activeClientData: ActiveClientData || {},
    categoryClientData: CategoryClientData,
    demographicClientData: DemographicClientData,
    standardCostOfCare: StandardCostOfCare,
    totalStandardCostOfCare: TotalStandardCostOfCare,
    SPBehavioralRating,
    ScoreImprovement,
    ProviderPerformance,
    triggerLocationActivity: TriggerLocationActivity,
    serviceDelivered: ServiceDelivered,
    ActiveClient,
    UnitsOfServiceDelivered,
    ClientInteraction,
    ReferralSource: ReferralSource,
    ProviderPerformancePercentage: ProviderPerformancePercentage,
    centerProgramType,
    center,
    defaultCenter,
    powerBI,
  };
};

export default connect(mapStateToProps)(DashboardAnalytics);
